import { createSelector } from "reselect";
import moment from 'moment';

const batteryStatus = state => state.tableBattery.results;

const handleBESSStatus = batteryState => {
  // this one if just for the operation data not for the dashboard

  switch (batteryState) {
    case 0:
      return "Disabled";
    case 1:
      return "Offline";
    case 2:
      return "Neutral";
    case 3:
      return "Charging";
    case 4:
      return "Discharging";
    case 5:
      return "Islanding Mode";
    case null:
      return "--";
    default:
      return "Available";
  }
};

const getData = (data) => {
  const batteryStatus = [...data];

  batteryStatus.forEach(item => {
    item.displayTimestamp = moment(item.timestamp).format(
      "DD/MM/YYYY HH:mm"
    );
    item.displayState =
      parseInt(item.p, 10) === 0
        ? "Idle"
        : handleBESSStatus(item.state);
  });

  return batteryStatus;
};

export default createSelector(
  batteryStatus,
  getData
);



// WEBPACK FOOTER //
// ./src/selectors/get_battery_status.js